





















import { Component, Mixins } from "vue-property-decorator";
import { ClientRoutes } from "@/data/enums/router";
import { ICrumb } from "@/components/app-base/UBreadcrumbs.vue";
import SupportTicketInjectorMixin from "@/mixins/supportTicketInjectorMixin";

@Component
export default class ClientTicketBillboard extends Mixins(
  SupportTicketInjectorMixin
) {
  public get breadcrumbs(): ICrumb[] {
    return [
      {
        label: this.$t("_.my_tickets"),
        route: {
          to: {
            name: ClientRoutes.SUPPORT_TICKETS
          }
        }
      }
    ];
  }
}
